import React from 'react';
import Notification from '../messagerie_user/notification';
import { Form, Card, Accordion } from 'react-bootstrap';

function AffichageInfoArbitre(props) {

  return (
    <>
      {props.userData && (
        <>
          {props.equipe && props.equipe.arbitre && (
            <>
              <div className="main equipes_info">
                <Notification userData={props.userData} />
                <div className="joueur">
                  <div className="image7">
                    <img src='/img/bel.png' alt="" width="100" height="100" />
                  </div>
                  <div className="nbr">Arbitre</div>
                  <div className="nom">
                    <a href={`/${props.type}/equipe/arbitre/${props.equipe.arbitre[0].id_arbitre}`}>
                      {props.equipe.arbitre[0].nom} {props.equipe.arbitre[0].prenom}
                    </a>
                  </div>
                </div>
                <div className="card">
                  <div className="card-body">
                    <table>
                      <tbody>
                        <tr>
                          <td>Nom</td>
                          <td>:</td>
                          <td>{props.equipe.arbitre[0].nom}</td>
                        </tr>
                        <tr>
                          <td>Prenom</td>
                          <td>:</td>
                          <td>{props.equipe.arbitre[0].prenom}</td>
                        </tr>
                        <tr>
                          <td>Date de naissance</td>
                          <td>:</td>
                          <td>{props.equipe.arbitre[0].naissance}</td>
                        </tr>
                        <tr>
                          <td>Numéro de téléphone</td>
                          <td>:</td>
                          <td>{props.equipe.arbitre[0].contact}</td>
                        </tr>
                        <tr>
                          <td>Adresse mail</td>
                          <td>:</td>
                          <td>{props.equipe.arbitre[0].email}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="mains equipe_info">
                <Card className="text-center" style={{ fontSize: "15px" }}>
                  <Card.Header>Avis sur les prestations</Card.Header>
                  <Accordion defaultActiveKey="1">
                    {props.equipe.avis.length !== 0 &&
                      props.equipe.avis.map((item, index) => (
                        <Accordion.Item key={index} eventKey={index}>
                          <Accordion.Header>
                            <div className="text-center mb-3">
                              {item.equipe_dom} {item.score} {item.equipe_ext}
                            </div>
                          </Accordion.Header>
                          <Accordion.Body>
                            <div className="rating-criteria">
                              <div className="rating-stars criteria1">
                                {[5, 4, 3, 2, 1].map(star => (
                                  <React.Fragment key={star}>
                                    <input
                                      type="radio"
                                      id={`star${star}_${item.id_candidature}`}
                                      name={`rating_${item.id_candidature}`}
                                      checked={item.note === star}
                                      value={star}
                                      disabled
                                    />
                                    <label htmlFor={`star${star}_${item.id_candidature}`}></label>
                                  </React.Fragment>
                                ))}
                              </div>
                            </div>
                            <Form.Label>Commentaire de l'arbitre</Form.Label>
                            <Form.Control
                              as="textarea"
                              value={item.commentaireArbitre !== null ? item.commentaireArbitre : ''}
                              disabled
                              rows={3}
                            />
                            <Form.Label>Commentaire du coach</Form.Label>
                            <Form.Control
                              as="textarea"
                              value={item.commentaireCoach !== null ? item.commentaireCoach : ''}
                              disabled
                              rows={3}
                            />
                          </Accordion.Body>
                        </Accordion.Item>
                      ))}
                  </Accordion>
                </Card>
                <br/>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
}

export default AffichageInfoArbitre;
